const options = {
  filter: true,
  filterType: "dropdown",
  responsive: "standard",
  fixedHeader: true,
  fixedSelectColumn: false,
  tableBodyHeight: "calc(100vh - 200px)",
  rowsPerPage: 50,
  rowsPerPageOptions: [10, 15, 20, 25, 50, 100],
  draggableColumns: {
    enabled: true,
  },
  selectableRows: "none",
  customSort: (data, colIndex, order) => {
    return data.sort((a, b) => {
      var aVal = a.data[colIndex];
      var bVal = b.data[colIndex];

      if (!aVal) aVal = 1000;
      if (!bVal) bVal = 1000;

      if (aVal < bVal) {
        return -1 * (order === "desc" ? -1 : 1);
      } else if (aVal > bVal) {
        return 1 * (order === "desc" ? -1 : 1);
      } else {
        return 0;
      }
    });
  },
  setTableProps: () => {
    return {
      padding: "default",
      size: "small",
    };
  },
};
const spec_options = {
  filter: true,
  filterType: "dropdown",
  responsive: "standard",
  fixedHeader: true,
  fixedSelectColumn: false,
  tableBodyHeight: "calc(100vh - 300px)",
  rowsPerPage: 50,
  rowsPerPageOptions: [10, 15, 20, 25, 50, 100],
  draggableColumns: {
    enabled: true,
  },
  selectableRows: "none",
  customSort: (data, colIndex, order) => {
    return data.sort((a, b) => {
      var aVal = a.data[colIndex];
      var bVal = b.data[colIndex];

      if (!aVal) aVal = 1000;
      if (!bVal) bVal = 1000;

      if (aVal < bVal) {
        return -1 * (order === "desc" ? -1 : 1);
      } else if (aVal > bVal) {
        return 1 * (order === "desc" ? -1 : 1);
      } else {
        return 0;
      }
    });
  },
  setTableProps: () => {
    return {
      padding: "default",
      size: "small",
    };
  },
};
const team_options = {
  filter: true,
  filterType: "dropdown",
  responsive: "standard",
  fixedHeader: true,
  fixedSelectColumn: false,
  tableBodyHeight: "calc(50vh - 150px)",
  rowsPerPage: 25,
  rowsPerPageOptions: [10, 15, 20, 25, 50, 100],
  draggableColumns: {
    enabled: true,
  },
  selectableRows: "none",
  customSort: (data, colIndex, order) => {
    return data.sort((a, b) => {
      var aVal = a.data[colIndex];
      var bVal = b.data[colIndex];

      if (!aVal) aVal = 1000;
      if (!bVal) bVal = 1000;

      if (aVal < bVal) {
        return -1 * (order === "desc" ? -1 : 1);
      } else if (aVal > bVal) {
        return 1 * (order === "desc" ? -1 : 1);
      } else {
        return 0;
      }
    });
  },
  setTableProps: () => {
    return {
      padding: "default",
      size: "small",
    };
  },
};

const columns = [
  {
    label: "Name",
    name: "name",
    options: {
      filter: false,
      sort: true,
      setCellProps: () => ({
        style: {
          whiteSpace: "nowrap",
          position: "sticky",
          left: "0",
          background: "white",
          zIndex: 100,
        },
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: "nowrap",
          position: "sticky",
          left: 0,
          background: "white",
          zIndex: 101,
        },
      }),
    },
  },
  {
    label: "Org",
    name: "org",
    options: {
      filter: true,
      sort: false,
    },
  },
  {
    label: "Pos",
    name: "pos",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    label: "FV",
    name: "fv",
    options: {
      filter: false,
      sort: true,
      sortDirection: "desc",
    },
  },
  {
    label: "Age",
    name: "age",
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    label: "ETA",
    name: "eta",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    label: "Top 100",
    name: "top100",
    options: {
      filter: false,
      sort: true,
      sortDirection: "asc",
    },
  },
  {
    label: "Fangraphs",
    name: "fangraphs",
    options: {
      filter: false,
      sort: false,
    },
  },
];

const p_columns = [
  {
    label: "Name",
    name: "name",
    options: {
      filter: false,
      sort: true,
      setCellProps: () => ({
        style: {
          whiteSpace: "nowrap",
          position: "sticky",
          left: "0",
          background: "white",
          zIndex: 100,
        },
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: "nowrap",
          position: "sticky",
          left: 0,
          background: "white",
          zIndex: 101,
        },
      }),
    },
  },
  {
    label: "Pos",
    name: "pos",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    label: "Team",
    name: "team",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    label: "DoB",
    name: "age",
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    label: "FG",
    name: "fg",
    options: {
      filter: false,
      sort: true,
      sortDirection: "asc",
    },
  },
  {
    label: "PLive",
    name: "plive",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    label: "Fantrax",
    name: "fantrax",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    label: "P361",
    name: "p361",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    label: "MLB",
    name: "mlb",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    label: "RotoBallers",
    name: "rotob",
    options: {
      filter: false,
      sort: true,
    },
  },
  // {
  //   label: "Razzball",
  //   name: "razz",
  //   options: {
  //     filter: false,
  //     sort: true,
  //   },
  // },
  {
    label: "CBS",
    name: "cbs",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    label: "Fantasy Pros",
    name: "fanpros",
    options: {
      filter: false,
      sort: true,
    },
  },
  // {
  //   label: "Fantasy Six Pack",
  //   name: "fantasysixpack",
  //   options: {
  //     filter: false,
  //     sort: true,
  //   },
  // },
  // {
  //   label: "Add To Watchlist",
  //   name: "Add",
  //   options: {
  //     filter: false,
  //     sort: false,
  //   },
  // },
];

const watch_columns = [
  {
    label: "Name",
    name: "name",
    options: {
      filter: false,
      sort: true,
      setCellProps: () => ({
        style: {
          whiteSpace: "nowrap",
          position: "sticky",
          left: "0",
          background: "white",
          zIndex: 100,
        },
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: "nowrap",
          position: "sticky",
          left: 0,
          background: "white",
          zIndex: 101,
        },
      }),
    },
  },
  {
    label: "Org",
    name: "org",
    options: {
      filter: true,
      sort: false,
    },
  },
  {
    label: "Pos",
    name: "pos",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    label: "Fangraphs",
    name: "fangraphs",
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    label: "Delete Player",
    name: "delete",
    options: {
      filter: false,
      sort: false,
    },
  },
];

const farm_columns = [
  {
    label: "Name",
    name: "name",
    options: {
      filter: false,
      sort: true,
      setCellProps: () => ({
        style: {
          whiteSpace: "nowrap",
          position: "sticky",
          left: "0",
          background: "white",
          zIndex: 100,
        },
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: "nowrap",
          position: "sticky",
          left: 0,
          background: "white",
          zIndex: 101,
        },
      }),
    },
  },
  {
    label: "Org",
    name: "org",
    options: {
      filter: true,
      sort: false,
    },
  },
  {
    label: "Pos",
    name: "pos",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    label: "FV",
    name: "fv",
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    label: "Fangraphs",
    name: "fangraphs",
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    label: "Delete Player",
    name: "delete",
    options: {
      filter: false,
      sort: false,
    },
  },
];
const team_columns = [
  {
    label: "Position",
    name: "pos",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    label: "Name",
    name: "name",
    options: {
      filter: false,
      sort: true,
      setCellProps: () => ({
        style: {
          whiteSpace: "nowrap",
          position: "sticky",
          left: "0",
          background: "white",
          zIndex: 100,
        },
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: "nowrap",
          position: "sticky",
          left: 0,
          background: "white",
          zIndex: 101,
        },
      }),
    },
  },
  {
    label: "Org",
    name: "org",
    options: {
      filter: true,
      sort: false,
    },
  },
  {
    label: "Salary",
    name: "salary",
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    label: "Contract",
    name: "contract",
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    label: "Delete Player",
    name: "delete",
    options: {
      filter: false,
      sort: false,
      // setCellProps: () => ({
      //   align: "left",
      // }),
    },
  },
  // {
  //   label: "Add To Watchlist",
  //   name: "Add",
  //   options: {
  //     filter: false,
  //     sort: false,
  //   },
  // },
];

module.exports = {
  options,
  spec_options,
  team_options,
  columns,
  p_columns,
  watch_columns,
  farm_columns,
  team_columns,
};
